import { Component, ChangeDetectorRef, OnInit } from '@angular/core';
import { ErrorResponse } from '@klickdata/core/http';
import { PasswordService } from '@klickdata/guest/src/forget-password/password.service';
import { Observable, filter, of, takeUntil } from 'rxjs';
import { FormGroup, FormBuilder, Validators, ValidatorFn, AbstractControl, ValidationErrors } from '@angular/forms';
import { ConfigService } from '@klickdata/core/config';
import { FormHelper } from '@klickdata/core/form';
import { Utils } from '@klickdata/core/util';
import { Customer, CustomerLanding } from '@klickdata/core/customer';
import { AuthService, Login } from '@klickdata/core/auth';
import { ActivatedRoute, Router } from '@angular/router';
import { OnDestroyHandler } from 'apps/klickdata/src/app/shared/onDestroy-handler/onDestroy-handler';

@Component({
    selector: 'app-forget-password',
    templateUrl: 'forget-password.component.html',
    styleUrls: ['forget-password.component.scss'],
})
export class ForgetPasswordComponent extends OnDestroyHandler implements OnInit {
    passwdForm: FormGroup;
    success: boolean;
    inPaymentContext: boolean;
    error: Observable<ErrorResponse<null>>;
    mailIsSend: boolean;
    academies: Customer[];
    public customerLanding$: Observable<CustomerLanding>;

    constructor(
        protected fb: FormBuilder,
        private password: PasswordService,
        protected configService: ConfigService,
        protected cdRef: ChangeDetectorRef,
        protected route: ActivatedRoute,
        protected router: Router,
        auth: AuthService
    ) {
        super();
        this.customerLanding$ = auth.getCustomerLanding();
        this.mailIsSend = false;
        this.passwdForm = fb.group({
            username: [null, Validators.required],
            short_name: [Utils.getSubdomain(), this.requiredWithAcademies()],
        });
    }
    ngOnInit(): void {
        this.route.queryParams.pipe(takeUntil(this.destroy)).subscribe((qp) => (this.inPaymentContext = qp?.payment));
    }
    requiredWithAcademies(): ValidatorFn {
        return (control: AbstractControl): ValidationErrors | null => {
            return this.academies && !control.value ? { academyRequired: true } : null;
        };
    }
    login() {
        if (this.inPaymentContext) {
            this.router.navigate(['/guest/payment-auth'], { queryParams: { paymentContext: 'login' } });
        } else {
            this.router.navigate(['/guest/login']);
        }
    }

    onSubmit() {
        if (this.passwdForm.invalid) {
            FormHelper.markForm(this.passwdForm);
            return;
        }
        this.password.sendResetEmail(new Login(this.passwdForm.value).getData()).subscribe(
            (data) => {
                if (Array.isArray(data)) {
                    this.academies = data.map((cusData) => new Customer(cusData));
                    this.cdRef.markForCheck();
                } else {
                    this.onDone();
                }
            },
            (err) => {
                this.success = false;
                this.error = of(err);
            }
        );
    }

    onDone() {
        const short_name = this.passwdForm.get('short_name');
        this.academies = null;
        short_name.setValue(null);
        short_name.setErrors(null);
        this.success = true;
        this.mailIsSend = true;
    }
}
